import React from "react";
import "./slot-time.styles.scss";
import { Flex, Switch, TimePicker } from "antd";
import dayjs from "dayjs";
import { ReactComponent as CloseBtn } from "../../assets/cancel.svg";
const { RangePicker } = TimePicker;

interface SlotTimeProps {
  slotId: number;
  slotNumber: number;
  value: Array<string>;
  onChange?: (id: number, timeString: any) => void;
  edited?: boolean;
  isPermanent?: boolean;
  onToggle: (id: number) => void;
  active?: boolean;
  isEdit?: boolean;
  activeToggle?: boolean;
  addSlot?: boolean;
}

const SlotTime: React.FC<SlotTimeProps> = (props: SlotTimeProps) => {
  const {
    slotId,
    slotNumber,
    value,
    onChange,
    isEdit,
    active,
    edited,
    isPermanent = true,
    onToggle,
    activeToggle,
    addSlot = false,
  } = props;
  const updatedProps = {
    ...(value &&
      value.length === 2 &&
      value[0] !== "" && {
        value: [dayjs(value[0], "HH:mm:ss"), dayjs(value[1], "HH:mm:ss")],
      }),
  };
  return (
    <div
      className={`single-slot-container ${!isEdit && "disabled"} ${
        !isPermanent && "today-view"
      } ${edited && "edited"}`}
    >
      <Flex gap={5}>
        {/* <div className="header">Slot {slotNumber}</div> */}
        <RangePicker
          // {...updatedProps}
          {...(value &&
            value.length === 2 &&
            value[0] !== "" && {
              defaultValue: [
                dayjs(value[0], "HH:mm:ss"),
                dayjs(value[1], "HH:mm:ss"),
              ],
            })}
          onChange={(value, timeString) =>
            onChange && onChange(slotId, timeString)
          }
          format={"hh:mm A"}
          //#region need to Check
          minuteStep={5}
          inputReadOnly={true}
          size="small"
        />
        {activeToggle && isEdit && (
          <Switch
            defaultChecked={active}
            disabled={!isEdit}
            onChange={() => onToggle(slotId)}
          />
        )}
      </Flex>
      {!isPermanent && <div className="temp-div">Changed for today</div>}
    </div>
  );
};

export default SlotTime;
